import { render, staticRenderFns } from "./add-subscription.html?vue&type=template&id=354e79bf&scoped=true&"
import script from "./add-subscription.js?vue&type=script&lang=js&"
export * from "./add-subscription.js?vue&type=script&lang=js&"
import style0 from "./add-subscription.scss?vue&type=style&index=0&id=354e79bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354e79bf",
  null
  
)

export default component.exports